export default __webpack_public_path__ + "img/Lindera_glauca.fc115d84.jpg";